import { render, staticRenderFns } from "./TTRemoveButton.vue?vue&type=template&id=5a37bb73&scoped=true"
import script from "./TTRemoveButton.vue?vue&type=script&lang=js"
export * from "./TTRemoveButton.vue?vue&type=script&lang=js"
import style0 from "./TTRemoveButton.vue?vue&type=style&index=0&id=5a37bb73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37bb73",
  null
  
)

export default component.exports